module.exports = __webpack_public_path__ + "static/media/Soft_Pastel.5f7d011a.webp";